import React from 'react'

import './styles/styles.css'

import File from 'views/pages/File'
import Hints from 'views/pages/UIElements/Hints'
import BlockColorPicker from '../BlockColorPicker'
import { Link } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { createTheme } from 'store/ConfigurationSettings/ThemeConfig/actions'
import { useDispatch } from 'react-redux'
import { onImageChange } from 'store/ConfigurationSettings/ThemeConfig/actions'
import { resetTheme } from 'store/ConfigurationSettings/ThemeConfig/actions'
import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'

// eslint-disable-next-line import/no-anonymous-default-export
const ThemeConfig = (props) => {
  const dispatch = useDispatch()
  const language = props.language?.data
  const themeConfig = props.themeConfig
  const createThemeMessage = () => {
    dispatch(createTheme())
      .then(() => {
        toast.success(language?.alerts.changes_saved_succesfully, {
          position: toast.POSITION.TOP_CENTER,
          className: 'general-settings-toast',
          autoClose: 4000,
        })
      })
      .catch(() => {
        toast.error(language?.alerts.failed_to_save_changes, {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: 'general-settings-toast',
          autoClose: 4000,
        })
      })
  }

  return (
    <div className='tab-content'>
      <div className='modules-options'>
        <h3>{language?.settings.change_background_images}</h3>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.logo}:</span>
            <Hints message={language?.hints.upload_logo} />
          </div>
          <div className='config-item'>
            <File
              placeholder={
                language?.general ? language?.general?.choose_file : null
              }
              onChange={(file, name) => dispatch(onImageChange(file, name))}
              name='logo'
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.background_image}:</span>
            <Hints message={language?.hints.upload_background} />
          </div>
          <div className='config-item'>
            <File
              placeholder={
                language?.general ? language?.general?.choose_file : null
              }
              onChange={(file, name) => dispatch(onImageChange(file, name))}
              name='background'
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.navigation_logo}:</span>
            <Hints message={language?.hints.upload_navlogo} />
          </div>
          <div className='config-item'>
            <File
              placeholder={
                language?.general ? language?.general?.choose_file : null
              }
              onChange={(file, name) => dispatch(onImageChange(file, name))}
              name='navlogo'
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.favicon}:</span>
            <Hints message={language?.hints.upload_favicon} />
          </div>
          <div className='config-item'>
            <File
              placeholder={
                language?.general ? language?.general?.choose_file : null
              }
              onChange={(file, name) => dispatch(onImageChange(file, name))}
              name='favicon'
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.login_logo}:</span>
            <Hints message={language?.hints.upload_loginlogo} />
          </div>
          <div className='config-item'>
            <File
              placeholder={
                language?.general ? language?.general?.choose_file : null
              }
              onChange={(file, name) => dispatch(onImageChange(file, name))}
              name='loginLogo'
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>App icon:</span>
            <Hints message={'Upload an image for app icon'} />
          </div>
          <div className='config-item'>
            <File
              placeholder={
                language?.general ? language?.general?.choose_file : null
              }
              onChange={(file, name) => dispatch(onImageChange(file, name))}
              name='appIcon'
            />
          </div>
        </div>
      </div>
      <div className='modules-options'>
        <h3>Sidebar theme colors</h3>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>Sidebar background</span>
            <Hints message={'Change the background color of sidebar'} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'theme'}
              option={'sidebarBackground'}
              optionColor={themeConfig.theme.sidebarBackground}
              handleColorChange={themeConfig.handleColorChange}
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>Sidebar active item color</span>
            <Hints message={'Change the color of the active item in sidebar'} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'theme'}
              option={'sidebarActiveColor'}
              optionColor={themeConfig.theme.sidebarActiveColor}
              handleColorChange={themeConfig.handleColorChange}
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>Sidebar text color</span>
            <Hints message={'Change the color of the text in sidebar'} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'theme'}
              option={'sidebarTextColor'}
              optionColor={themeConfig.theme.sidebarTextColor}
              handleColorChange={themeConfig.handleColorChange}
            />
          </div>
        </div>
      </div>
      <div className='modules-options'>
        <h3>{language?.settings.change_theme_colors}</h3>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.top_bar_color}</span>
            <Hints message={language?.hints.topbar_color} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'theme'}
              option={'color'}
              optionColor={themeConfig.theme.color}
              handleColorChange={themeConfig.handleColorChange}
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.navbar_color}</span>
            <Hints message={language?.hints.navbar_color} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'theme'}
              option={'navColor'}
              optionColor={themeConfig.theme.navColor}
              handleColorChange={themeConfig.handleColorChange}
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.navbar_text_color}</span>
            <Hints message={language?.hints.navbar_text_color} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'theme'}
              option={'navTextColor'}
              optionColor={themeConfig.theme.navTextColor}
              handleColorChange={themeConfig.handleColorChange}
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.navbar_icon_color}</span>
            <Hints message={language?.hints.navbar_icon_color} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'theme'}
              option={'navIconColor'}
              optionColor={themeConfig.theme.navIconColor}
              handleColorChange={themeConfig.handleColorChange}
            />
          </div>
        </div>
        <div className='config-row'>
          <div className='with-hint item'>
            <span>{language?.settings.topbar_icon_color}</span>
            <Hints message={language?.hints.topbar_icon_color} />
          </div>
          <div className='config-item'>
            <BlockColorPicker
              from={'theme'}
              option={'topbarIconColor'}
              optionColor={themeConfig.theme.topbarIconColor}
              handleColorChange={themeConfig.handleColorChange}
            />
          </div>
        </div>
      </div>
      <div className='col my-4'>
        <SubmitModalButton
          text={themeConfig.status || language?.general.save}
          customFn={createThemeMessage}
        />
        <Link to='/dashboard'>
          <CancelModalButton
            text={language?.general.cancel}
            customFn={() => dispatch(resetTheme())}
          />
        </Link>
      </div>
      <ToastContainer />
    </div>
  )
}

export default ThemeConfig
